// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1d8hC","col":"styles_col__2dhg2","fulfillmentStatus":"styles_fulfillmentStatus__3tXgg","emailCol":"styles_emailCol__3uD2y"};